import { render, staticRenderFns } from "./company-profile.vue?vue&type=template&id=443b0054&"
import script from "./company-profile.js?vue&type=script&lang=js&"
export * from "./company-profile.js?vue&type=script&lang=js&"
import style0 from "./company-profile.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports